<template>
  <div class="orders-table">
    <DataTable
      data-testid="orders-table"
      :columns="columns"
      :data="orders"
      :items-per-page="itemsPerPage"
      :status="status"
      @on-row-click="emitOnOrderClick"
    >
      <template #empty>
        <OrdersTableEmptyState
          class="orders-table__helper"
          :has-filter-selected="hasFilterSelected"
          @on-clear-filters="emitOnClearFilters"
        />
      </template>
      <template #error>
        <HelperViewStatus
          class="orders-table__helper"
          status="alert"
          button-label="Tentar novamente"
          title="Desculpe, não conseguimos carregar as suas ordens"
          description="Aguarde um momento e tente novamente"
          @click="emitOnRetry"
        />
      </template>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import { DataTable, HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { OrdersTableEmptyState } from './components/OrdersTableEmptyState';

import { columns } from './columns';
import { PortfolioOrder } from '@/modules/wealth/services/portfolio';
import { FetchOrdersStatus } from '@/modules/wealth/views/IndexPortfolio/components/Orders/types';

interface Props {
  orders: PortfolioOrder[];
  itemsPerPage: number;
  hasFilterSelected: boolean;
  status: FetchOrdersStatus;
}
defineProps<Props>();

interface Emit {
  (event: 'on-order-click', order: PortfolioOrder): void;
  (event: 'on-retry'): void;
  (event: 'on-clear-filters'): void;
}
const emit = defineEmits<Emit>();

const emitOnOrderClick = (order: PortfolioOrder) => {
  emit('on-order-click', order);
};

const emitOnClearFilters = () => {
  emit('on-clear-filters');
};

const emitOnRetry = () => {
  emit('on-retry');
};
</script>

<style lang="less" scoped>
.orders-table {
  padding: @size-spacing-x500;
  border: @size-border-x400 solid @divider-primary;
  border-radius: @size-radius-x200;

  :deep(th) {
    white-space: nowrap;
  }

  :deep(td:not(:first-child)) {
    white-space: nowrap;
  }

  &__helper {
    margin: @size-spacing-x1000 auto @size-spacing-x1000 auto;
  }
}
</style>
